import { Column } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const ErrorState = () => {
  const { t } = useLocalization()

  return (
    <Column className="min-h-dvh items-center justify-center bg-[#f4f5f7] px-5">
      <p className="text-neutral-600">
        {t('Quote not found', 'Offerten hittades inte')}
      </p>
    </Column>
  )
}
